@if (courseCategoryData) {
  <div class="dialogContainer">
    <div class="dialogHeader">
      <img class="closeDialogBtn" (click)="closeDialog()" />
    </div>
    <div class="dialogContent">
      <app-dialog-input-title
        title="Kursus kategori"
        [required]="true"
      ></app-dialog-input-title>
      <input type="text" class="textbox" [(ngModel)]="courseCategoryData.name" />
    </div>
    <div class="dialogFooter">
      <app-save-button
        [disabled]="!courseCategoryData.name.trim()"
        [clickEvent]="saveChanges.bind(this)"
        >
      </app-save-button>
      <app-delete-button [clickEvent]="deleteCourseCategory.bind(this)">
      </app-delete-button>
    </div>
  </div>
}
